/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerCreatedBy } from './after-order-banner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerImage } from './after-order-banner-image';

/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'title'?: string;
    /**
     * 
     * @type {AfterOrderBannerImage}
     * @memberof Banner
     */
    'image'?: AfterOrderBannerImage;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'urlPattern'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'web'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'android'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'ios'?: boolean;
    /**
     * 
     * @type {AfterOrderBannerImage}
     * @memberof Banner
     */
    'desktopImage'?: AfterOrderBannerImage;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'position'?: BannerPositionEnum;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'whiteLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'displaySize'?: BannerDisplaySizeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'international'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'privacy'?: BannerPrivacyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'androidWebApp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Banner
     */
    'iosWebApp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'reserveType'?: BannerReserveTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'searchResult'?: BannerSearchResultEnum;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof Banner
     */
    'created_by'?: AfterOrderBannerCreatedBy;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof Banner
     */
    'updated_by'?: AfterOrderBannerCreatedBy;
}

export const BannerPositionEnum = {
    Loading: 'loading',
    List: 'list',
    TaxiBanner: 'taxiBanner',
    HotelBanner: 'hotelBanner'
} as const;

export type BannerPositionEnum = typeof BannerPositionEnum[keyof typeof BannerPositionEnum];
export const BannerDisplaySizeEnum = {
    Both: 'both',
    Mobile: 'mobile',
    Desktop: 'desktop'
} as const;

export type BannerDisplaySizeEnum = typeof BannerDisplaySizeEnum[keyof typeof BannerDisplaySizeEnum];
export const BannerPrivacyEnum = {
    All: 'all',
    Unauthorized: 'unauthorized',
    Normal: 'normal',
    Organizational: 'organizational'
} as const;

export type BannerPrivacyEnum = typeof BannerPrivacyEnum[keyof typeof BannerPrivacyEnum];
export const BannerReserveTypeEnum = {
    All: 'all',
    Flight: 'flight',
    Train: 'train',
    Bus: 'bus',
    Hotel: 'hotel',
    Taxi: 'taxi'
} as const;

export type BannerReserveTypeEnum = typeof BannerReserveTypeEnum[keyof typeof BannerReserveTypeEnum];
export const BannerSearchResultEnum = {
    Empty: 'empty',
    NonEmpty: 'nonEmpty',
    Both: 'both'
} as const;

export type BannerSearchResultEnum = typeof BannerSearchResultEnum[keyof typeof BannerSearchResultEnum];


